import React from 'react'

import Page from '../Page'
import LogoBlock from '../../LogoBlock'

const ShortTextPanel = ({
  id,
  panelColor,
  panelTexture,
  panelLabel,
  panelLabelColor,
  ...blockProps
}) => {
  return (
    <Page.Panel noPadding color={panelColor} texture={panelTexture} key={`panel${id}`}>
      {panelLabel && (
        <Page.Panel.Label color={panelLabelColor}>
          {panelLabel}
        </Page.Panel.Label>
      )}
      <LogoBlock {...blockProps} />
    </Page.Panel>
  )
}

export default ShortTextPanel
